import { useContext, useEffect } from "react";
import { Context } from "../Context/Context";
import { useApi } from "./Api";
import { useToast } from "./Toast";

export const useRole = () => {
  const context = useContext(Context);
  let roles = context.roles.map((r) => r.name);

  const can = (role) => {
    return roles.includes(role);
  };

  const canBoard = () => {
    return roles?.find((u) => u?.startsWith("Board")) !== undefined;
  };

  return {
    can: (role) => can(role),
    canBoard: () => canBoard(),
  };
};
